<template>
  <div class="iphone-body">
    <img :src="modelMask.shadow2" class="shadow" alt="" />
    <div class="brand-qrcode-container">
      <img :src="qrcode" alt="示例的二维码" class="qrcode" />
      <div class="description">
        微信扫码体验
      </div>
    </div>
    <img :src="image" class="brand-image" alt="示例图片" />
    <img :src="modelMask[`${phoneStyle}`]" alt="iPhone X 遮罩" class="mask" />
    <qm-button
      v-if="showCreate"
      class="create"
      text="新建同类型小程序"
      @click.native="$emit('createPublication')"
    />
  </div>
</template>

<script>
/* eslint-disable */
import {mapGetters, mapMutations, mapActions, mapState} from 'vuex'
import * as api from 'src/api/index'
import * as qm from 'src/utils/utils'
import * as formatter from 'src/utils/formatter'
import _ from 'lodash'
import VStore from 'src/store/state'
/* eslint-enable */
export default {
  name: 'PhoneModel',
  props: {
    showCreate: {
      type: Boolean,
      default: false,
    },
    phoneStyle: {
      type: String,
      default: 'dark',
    },
    image: {
      type: String,
      required: true,
    },
    qrcode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      modelMask: {
        dark: 'http://statics01.readland.cn/iPhone_Model_Mask_dark.png',
        light: 'http://statics01.readland.cn/iPhone_Model_Mask_light.png',
        shadow1: 'http://statics01.readland.cn/iPhone_Model_Mask_Shadow_1.png',
        shadow2: 'http://statics01.readland.cn/iPhone_Model_Mask_Shadow_2.png',
      },
    }
  },
}
</script>

<style lang="scss">
.iphone-body {
  position: relative;
  width: 429px;
  height: 862px;

  &:hover {
    .brand-image {
      opacity: 0;
    }

    .brand-qrcode-container {
      opacity: 1;
    }

    .create {
      opacity: 1;
    }
  }

  .shadow {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 0;
    transform: scale3d(1.04, 1.02, 1);
  }
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 1;
  }

  .brand-image {
    opacity: 1;
    position: absolute;
    top: 24px;
    left: 26px;
    height: 814px;
    width: 377px;
    z-index: 0;
    transition: opacity 500ms;
  }

  .brand-qrcode-container {
    opacity: 0;
    position: absolute;
    top: 24px;
    left: 26px;
    height: 814px;
    width: 377px;
    z-index: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #ffffff;
    transition: opacity 500ms;

    .qrcode {
      width: 185px;
      height: 185px;
      margin-top: 155px;
    }

    .description {
      font-size: 20px;
      line-height: 20px;
      font-weight: 400;
      margin-top: 24px;
      color: #666666;
    }
  }

  .create {
    position: absolute;
    z-index: 3;
    bottom: 15%;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    height: auto;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    padding: 8px 16px;
    opacity: 0;
    transition: opacity 500ms;
  }
}
</style>
